import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { internalControlsEnabled } from '../utils/permissions';
import type { BootstrapResponse } from '../api/bootstrap';

type Props = {
  bootstrap: BootstrapResponse | null;
  isCollapsedDesktop: boolean;
  onNavigate: () => void;
};

/**
 * Sidebar nav link for operator mailbox sync diagnostics (internal build + role only).
 */
export function maybeRenderOperatorMailboxSyncDiagnosticsNav({
  bootstrap,
  isCollapsedDesktop,
  onNavigate,
}: Props): React.ReactNode {
  if (!internalControlsEnabled(bootstrap?.user?.role)) {
    return null;
  }

  return (
    <div data-testid="NAV_OPERATOR_MAILBOX_SYNC_DIAGNOSTICS">
      <NavLink
        to="/app/operator/mailbox-sync-diagnostics"
        aria-label="Mailbox sync diagnostics"
        title={isCollapsedDesktop ? 'Mailbox sync diagnostics' : undefined}
        onClick={onNavigate}
        className={({ isActive }) =>
          [
            'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
            isActive ? 'bg-accent-muted text-theme font-medium' : 'text-theme hover:bg-theme-tertiary',
            isCollapsedDesktop ? 'justify-center px-2' : '',
          ].join(' ')
        }
      >
        <FontAwesomeIcon icon={faEnvelopeCircleCheck} className="h-4 w-4 shrink-0" />
        {!isCollapsedDesktop ? <span>Sync diagnostics</span> : null}
      </NavLink>
    </div>
  );
}
